import React from "react";
import { useGetLeasedEquipment } from "../../CarrierAgreementMgmt/LeasedEquipment/hooks/useGetLeasedEquipment";
import { ChevronRightIcon, PrinterIcon } from "@heroicons/react/24/solid";
import { RedirectTo } from "../../../routes/RedirectTo";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import {
  mainSelectedTab,
  permittedTabs,
} from "../../CarrierAgreementMgmt/atoms";
import { useGetLeasedEquipmentCount } from "../../CarrierAgreementMgmt/LeasedEquipment/hooks/useGetLeasedEquipmentCount";

const LeasedEquipmentCard = () => {
  const history = useHistory();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [usersTabs] = useRecoilState<any>(permittedTabs);
  const { data: leasedEquipment } = useGetLeasedEquipmentCount();
  const leasedEquipmentCount = leasedEquipment?.data;
  return (
    <div className="w-full bg-white shadow-md px-2 rounded-lg">
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <div>
            <PrinterIcon className="text-CereluanFrost bg-cyan-500 bg-opacity-20 rounded-lg h-7 w-7 p-1" />
          </div>
          <div className="flex flex-col leading tight">
            <h3 className="text-xs1 font-medium text-gray-500">
              Leased Equipments
            </h3>
            <h1 className="mr-auto font-bold text-primary text-lg">
              {leasedEquipmentCount}
            </h1>
          </div>
        </div>
        <div
          className="flex justify-end"
          onClick={() =>
            RedirectTo({
              urlPath: "/carrieragreementmgmt/leasedequipment",
              history: history,
              usersTabs: usersTabs,
              setSelectedIndex: setSelectedIndex,
            })
          }
        >
          <ChevronRightIcon className="h-5 w-5 p-1 bg-gray-200 rounded-full text-CereluanFrost transition cursor-pointer" />
        </div>
      </div>
    </div>
  );
};

export default LeasedEquipmentCard;
